// Libs
import React from 'react'
// Styles
import styles from './Nav.module.scss'
// Config
import { SITE_NAV } from 'config/nav.config'

// ─────────────────────────────────────────────────────────────────────────────
// 顶部站间导航：与博客站顶部那一排保持一致（首页 丨 文章 丨 碎碎念 丨 相册 丨
// 留言板 丨 友链 丨 关于），点哪一项都去博客站。
//
// 刻意**不带**博客 header 里的头像 / 搜索框 / 主题开关：
// 相册站自己的主题开关在右上角，另有其用，重复放一个只会互相打架。
//
// 视觉参数照抄博客主题（.header 高 64px、.nav-btn-text 字号 15 / 字重 600 /
// letter-spacing 0.5px、项间「丨」分隔）；颜色一律走本站主题令牌，
// 所以明暗两种模式自动跟随，不写死任何颜色。
// ─────────────────────────────────────────────────────────────────────────────

interface NavProps {
  // 放大看图时整页 chrome 退场，导航一起淡出（与 Footer / ThemeToggle 同一机制）
  hidden?: boolean
}

const Nav = ({ hidden }: NavProps) => (
  <header
    className={`${styles.nav}${hidden ? ` ${styles.navHidden}` : ''}`}
    aria-label="站点导航"
  >
    <nav className={styles.inner}>
      {SITE_NAV.map((item, index) => (
        <React.Fragment key={item.label}>
          {index > 0 ? <span className={styles.separator} aria-hidden="true">丨</span> : null}
          {item.children && item.children.length > 0 ? (
            <div className={styles.dropdown}>
              <a className={styles.link} href={item.href} title={item.label}>{item.label}</a>
              <div className={styles.menu}>
                {item.children.map((child) => (
                  <a key={child.href} className={styles.menuItem} href={child.href}>
                    {child.label}
                  </a>
                ))}
              </div>
            </div>
          ) : (
            <a className={styles.link} href={item.href} title={item.label}>{item.label}</a>
          )}
        </React.Fragment>
      ))}
    </nav>
  </header>
)

export default Nav
